import { render } from "./Contact.vue?vue&type=template&id=70cfdbec"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=70cfdbec&lang=css"
script.render = render

export default script